<template>
  <v-flex>
    <v-card class="pa-5 elevation-0" flat>
      <h1 class="fonte text-uppercase">Créditos</h1>
      <p class="black--text">Disponibilização automática de saldo em até 72 horas após o pagamento
      </p>
      <v-divider class="mt-3"></v-divider>
      <v-layout
        justify-space-between="justify-space-between"
        row="row"
        wrap="wrap"
        style="margin-top:50px;"
      >
        <v-flex md12="md12">
          <v-select
            item-text="text"
            color="blue-grey"
            item-value="value"
            v-model="plano"
            box="box"
            :items="planos"
            label="Pacote"
            required
            :rules="[() =&gt; !!plano || 'O campo Pacote é obrigatório']"
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout
        justify-space-between="justify-space-between"
        row="row"
        wrap="wrap"
        v-if="this.getUserLocal"
      >
        <v-flex md6="md6">
          <v-text-field
            v-model="getUserLocal.firstname"
            color="blue-grey"
            box="box"
            label="Nome"
            placeholder="Nome"
            required
            :rules="[() =&gt; !!getUserLocal.firstname || 'O campo Nome é obrigatório']"
          >
          </v-text-field>
        </v-flex>
        <v-flex md5="md5">
          <v-text-field
            v-model="getUserLocal.lastname"
            color="blue-grey"
            box="box"
            label="Sobrenome"
            placeholder="Sobrenome"
            required
            :rules="[() =&gt; !!getUserLocal.lastname || 'O campo Sobrenome é obrigatório']"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        justify-space-between="justify-space-between"
        row="row"
        wrap="wrap"
      >
        <v-flex md12="md12">
          <v-text-field
            v-model="getUserLocal.cpf_cnpj"
            color="blue-grey"
            box="box"
            label="CNPJ/CPF"
            placeholder="CNPJ/CPF"
            required
            :rules="[() =&gt; !!getUserLocal.cpf_cnpj || 'O campo CNPJ/CPF é obrigatório']"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        justify-space-between="justify-space-between"
        row="row"
        wrap="wrap"
      >
      <v-flex md6="md6">
        <v-text-field
          v-model="getUserLocal.zip_code"
          color="blue-grey"
          label="CEP"
          box="box"
          required
          :rules="[() =&gt; /^[0-9]{5}-[0-9]{3}$/.test(this.getUserLocal.zip_code) || 'Informe um cep válido']"
          placeholder="Cep Ex: #####-###"
          v-mask="'#####-###'"
        >
        </v-text-field>
      </v-flex>
      <v-flex md5="md5">
        <v-text-field
          v-model="getUserLocal.number"
          color="blue-grey"
          label="Número"
          box="box"
          placeholder="Número"
          required
          :rules="[() =&gt; !!getUserLocal.number || 'O campo Número é obrigatório']"
        >
        </v-text-field>
      </v-flex>
      <v-flex md12="md12">
        <v-text-field
          v-model="getUserLocal.email"
          color="blue-grey"
          label="E-mail"
          box="box"
          placeholder="E-mail"
          required
          :rules="[() =&gt; !!getUserLocal.email || 'O campo Email é obrigatório']"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :loading="isLoading"
        :disabled="isLoading || !validate"
        color="fundo"
        @click="send"
        round
        large
      >
      <v-icon left>monetization_on</v-icon>
        Gerar boleto
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </template>
      </v-btn>
    </v-card-actions>

  </v-card>
  <v-divider ></v-divider>
  <v-card class="padding elevation-0" flat>
    <h1 class="fonte mb-2 text-uppercase">Histórico de compras</h1>
    <v-data-table
      :headers="headers"
      :items="this.boletos"
      class="elevation-1"
      :rows-per-page-items="[20]"
      :loading="loadingBoletos"
    >
      <template
        v-slot:items="props"
      >
        <td>{{ getStatusBoleto(props.item.status) }}</td>
        <td>{{ props.item.createdAt }}</td>
        <td>{{ props.item.total }}</td>
        <td class="text-xs-center">
          <v-btn round color="fundo" dark :href="props.item.url" target="_blank">
            <v-icon>attach_file</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </v-card>
</v-flex>

</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    data(){
      return {
         headers: [
          { text: 'Status', sortable: false },
          { text: 'Data', sortable: false },
          { text: 'Valor', sortable: false },
          { text: 'Boleto', align: 'center', sortable: false }
        ],
        planos:[
          {text:"5.000 créditos (R$ 528,96)", value:"plan1"},
          {text:"10.000 créditos (R$ 978,58)", value:"plan2"},
          {text:"20.000 créditos (R$ 1.891,03)", value:"plan3"},
          {text:"50.000 créditos (R$ 4.463,10)", value:"plan4"},
          {text:"100.000 créditos (R$ 8.793,96)", value:"plan5"}
        ],
        plano: '',
        isLoading: false,
        boletos: [],
        loadingBoletos: true
      }
    },
    methods: {
      ...mapActions(['loadUserLocal', 'createBoleto', 'loadBoletos']),
      async send () {
        if (this.plano) {
          this.isLoading = true
          let resp = await this.createBoleto(this.plano)
          if (resp.status) {
            this.loadingBoletos = true
            this.boletos = await this.loadBoletos()
            this.loadingBoletos = false
            window.open(resp.data.url,'_blank');
          }else{
            //console.log('Erro ao gerar boleto')
          }
          this.isLoading = false
        } else {
          this.$eventHub.emit('snackBar', {message: 'Selecione um pacote'})
        }

      },
      getStatusBoleto (status) {
        switch (status) {
          case 'paid':
            return 'Pago'

          case 'pending':
            return 'Pendente'

          default:
            return status
        }
      }
    },
    async mounted () {
      let userLocal = await this.loadUserLocal()

      this.boletos = await this.loadBoletos()
      this.loadingBoletos = false
    },
    computed: {
      getUserLocal () {
        return this.$store.getters.getUserLocal
      },

      validate() {
        return !!(
          this.plano &&
          this.getUserLocal.firstname &&
          this.getUserLocal.lastname &&
          this.getUserLocal.cpf_cnpj &&
          this.getUserLocal.zip_code &&
          this.getUserLocal.number &&
          this.getUserLocal.email
        )
      }
    }

  }
</script>




// WEBPACK FOOTER //
// src/components/user/Comprarcreditos.vue